export interface SearchQuickExample {
    category: string;
    query: string;
}

export const SEARCH_CONFIG = {
    system: {
        embeddingModel: 'BAAI/bge-m3',
        biEncoderModel: 'BAAI/bge-m3',
        crossEncoderModel: 'BAAI/bge-reranker-v2-m3',
        vectorDatabase: 'Milvus 2.4',
        chunkingVersion: 'v1.0'
    },
    dataSource: {
        connection: '실 DB 미연결',
        mode: 'Frontend mock',
        searchData: 'src/portal/season/libs/search-mock.ts',
        metrics: 'src/portal/season/libs/search-config.ts',
        evaluationStore: 'data/search-evaluations.mock.json'
    },
    databaseSources: [
        {
            name: 'ScienceON',
            status: 'Mock 적재 기준',
            access: 'scienceon_custom_ocr XML 배치 적재',
            version: '2026.07 전수 분석 스냅샷',
            cycle: '운영 연동 시 협의 확정',
            rawData: '원천 XML · 수식 이미지 경로',
            structuredData: '문서 · 섹션 · 표/그림 캡션 청크',
            metadata: 'document_id 기준 DOI · ISSN · 저널 · 저자 연계'
        },
        {
            name: 'arXiv',
            status: '연동 설계안',
            access: 'API · OAI-PMH 수집 검토',
            version: '연동 전 · 스키마 명세 단계',
            cycle: '증분 수집 주기 협의 확정',
            rawData: '원문 PDF · 소스 패키지',
            structuredData: '메타데이터 XML · 섹션/본문 정규화',
            metadata: 'arXiv ID · 버전 · 카테고리 · 라이선스 연계'
        }
    ],
    normalizedSchema: [
        'source_id · source_version',
        'document_id · DOI · ISSN',
        'title · authors · journal · year',
        'section · page · chunk_type',
        'bi_encoder_score · cross_encoder_score',
        'previous · current · next 문맥',
        'embedding_model · indexed_at'
    ],
    updatePipeline: [
        '원천 수집',
        '파싱 · 정규화',
        '섹션 · 캡션 청킹',
        '임베딩 · 색인',
        '증분 갱신 · 실패 재처리',
        '승인 질의셋 품질 검증'
    ],
    qualityGoals: [
        { label: '문맥 · 출처 메타데이터 포함', target: '100%', scope: '검색 결과 응답' },
        { label: '리랭킹 검색 정확도 향상', target: '5% 이상', scope: '기준 검색 대비' },
        { label: '응답 · 근거 일치율', target: '95% 이상', scope: '승인 질의셋' },
        { label: '잘못된 출처 비율', target: '3% 미만', scope: '자동 평가' },
        { label: '미근거 주장 비율', target: '3% 이하', scope: '근거 부족 차단' },
        { label: '적정 거부율', target: '5% 이하', scope: '저관련도 질의' }
    ],
    retrievalTests: [
        { label: 'MRR', target: '승인 기준 통과', status: '실 DB 연동 후 측정' },
        { label: 'Recall@K', target: '승인 기준 통과', status: '실 DB 연동 후 측정' }
    ],
    dataProfile: {
        schema: 'scienceon_custom_ocr',
        xmlParseRate: '100%',
        identifier: 'document_id',
        formulaPolicy: '이미지 경로 참조 · 기본 검색 제외',
        indexScopes: [
            { label: '본문 보유 문서', status: '검색 포함', tone: 'included' },
            { label: '캡션 전용 문서', status: '검색 포함', tone: 'caption' },
            { label: '본문·캡션 없음', status: '검색 제외', tone: 'excluded' }
        ]
    },
    metrics: {
        totalDocuments: {
            label: '전체 XML 문서',
            value: '1,233,375',
            unit: '건',
            note: 'XML 직접 파싱 가능 100%'
        },
        searchableDocuments: {
            label: '검색 가능 문서',
            value: '1,172,181',
            unit: '건',
            note: '본문 보유 + 캡션 전용'
        },
        excludedDocuments: {
            label: '검색 제외 문서',
            value: '61,194',
            unit: '건',
            note: '본문·캡션 모두 없음'
        },
        cleanData: {
            label: '운영 클린 데이터',
            value: '95.04',
            unit: '%',
            progress: 95.04
        },
        xmlParse: {
            label: 'XML 직접 파싱',
            value: '100',
            unit: '%',
            progress: 100
        }
    },
    quickSearches: [
        {
            category: '에너지 · 소재',
            query: '리튬이온전지의 열폭주를 예측하는 머신러닝 연구를 찾아줘'
        },
        {
            category: '기후 · 농업',
            query: '기후변화가 한반도 농업 생산성에 미치는 영향을 분석한 논문'
        },
        {
            category: '의료 · 인공지능',
            query: '의료 영상에서 설명 가능한 인공지능을 적용한 국내 연구 동향'
        }
    ] as SearchQuickExample[],
    dataReference: 'ScienceON XML 전수 분석 기준',
    lastUpdated: '2026. 07 기준'
};
